<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">
                    {{ confirmInfo.title }}
                </div>
                <div class="dialog-body">
                    {{ confirmInfo.description }}
                    <div v-if="confirmInfo.type === CONFIRM_RESET_FLUSHING" class="dialog-checkbox">
                        <el-checkbox v-model="skipped"><span v-t="'message.skip_paid_message'"></span></el-checkbox><br/>
                        <span v-t="'message.skip_paid_message_caution'" style="color: red;"></span>
                    </div>
                </div>
                <div class="form-button-field">
                    <el-button class="dialog-cancel-button" style="width:160px" @click="$emit('cancel')" v-t="'message.button_no'"></el-button>
                    <el-button class="dialog-ok-button" style="width:160px" @click="agree" v-t="'message.button_yes'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            skipped: false,
            CONFIRM_RESET_FLUSHING: 1,
        }
    },
    props: [ 'confirmInfo' ],
    methods: {
        agree() {
            this.$emit('agree', this.skipped);
        }
    }
}

</script scoped>
<style scoped>
.dialog-body {
    padding: 20px;
    font-size: 14px;
}

.dialog-checkbox {
    margin-top: 10px;
}

.dialog-title {
    padding-top: 30px;
    height: 60px;
    text-align: center;
    vertical-align: middle;
    font-size: 24px;
    font-weight: 700;
    display: block;
}

.form-button-field {
    padding-top: 10px;
    padding-bottom: 20px;
    text-align: center;
}

.checkAgreement {
    padding: 20px;
    text-align: center;
}
.checkAgreement >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5171cb;
    border-color: #5171cb;
}

.checkAgreement >>> .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #333b48;
}

.checkAgreement >>> .el-checkbox {
    color: #848991;
}

</style>
